"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFT = exports.NFTSortBy = void 0;
const validation_1 = require("../validation");
const body_shape_1 = require("./body-shape");
const chain_id_1 = require("./chain-id");
const network_1 = require("./network");
const nft_category_1 = require("./nft-category");
const rarity_1 = require("./rarity");
const wearable_category_1 = require("./wearable-category");
var NFTSortBy;
(function (NFTSortBy) {
    NFTSortBy["NAME"] = "name";
    NFTSortBy["NEWEST"] = "newest";
    NFTSortBy["RECENTLY_LISTED"] = "recently_listed";
    NFTSortBy["RECENTLY_SOLD"] = "recently_sold";
    NFTSortBy["CHEAPEST"] = "cheapest";
})(NFTSortBy = exports.NFTSortBy || (exports.NFTSortBy = {}));
var NFT;
(function (NFT) {
    NFT.schema = {
        type: 'object',
        properties: {
            id: {
                type: 'string'
            },
            tokenId: {
                type: 'string'
            },
            contractAddress: {
                type: 'string'
            },
            activeOrderId: {
                type: ['string'],
                nullable: true
            },
            owner: {
                type: 'string'
            },
            name: {
                type: 'string'
            },
            image: {
                type: 'string'
            },
            url: {
                type: 'string'
            },
            data: {
                type: 'object',
                nullable: false,
                properties: {
                    parcel: {
                        type: 'object',
                        properties: {
                            description: {
                                type: ['string'],
                                nullable: true
                            },
                            x: {
                                type: 'string'
                            },
                            y: {
                                type: 'string'
                            },
                            estate: {
                                type: 'object',
                                properties: {
                                    tokenId: {
                                        type: 'string'
                                    },
                                    name: {
                                        type: 'string'
                                    }
                                },
                                required: ['tokenId', 'name'],
                                nullable: true
                            }
                        },
                        required: ['description', 'x', 'y', 'estate'],
                        nullable: true
                    },
                    estate: {
                        type: 'object',
                        properties: {
                            description: {
                                type: ['string'],
                                nullable: true
                            },
                            size: {
                                type: 'integer'
                            },
                            parcels: {
                                type: 'array',
                                items: {
                                    type: 'object',
                                    properties: {
                                        x: {
                                            type: 'number'
                                        },
                                        y: {
                                            type: 'number'
                                        }
                                    },
                                    required: ['x', 'y']
                                }
                            }
                        },
                        required: ['description', 'size', 'parcels'],
                        nullable: true
                    },
                    wearable: {
                        type: 'object',
                        properties: {
                            bodyShapes: {
                                type: 'array',
                                items: body_shape_1.BodyShape.schema
                            },
                            category: wearable_category_1.WearableCategory.schema,
                            description: {
                                type: 'string'
                            },
                            rarity: rarity_1.Rarity.schema
                        },
                        required: ['bodyShapes', 'category', 'description', 'rarity'],
                        nullable: true
                    },
                    ens: {
                        type: 'object',
                        properties: {
                            subdomain: {
                                type: 'string'
                            }
                        },
                        required: ['subdomain'],
                        nullable: true
                    }
                },
                required: []
            },
            issuedId: {
                type: 'string',
                nullable: true
            },
            itemId: {
                type: 'string',
                nullable: true
            },
            category: nft_category_1.NFTCategory.schema,
            network: network_1.Network.schema,
            chainId: chain_id_1.ChainId.schema,
            createdAt: {
                type: 'integer'
            },
            updatedAt: {
                type: 'integer'
            },
            soldAt: {
                type: 'integer'
            }
        },
        required: [
            'id',
            'tokenId',
            'contractAddress',
            'activeOrderId',
            'owner',
            'name',
            'image',
            'url',
            'data',
            'issuedId',
            'itemId',
            'category',
            'network',
            'chainId',
            'createdAt',
            'updatedAt',
            'soldAt'
        ]
    };
    NFT.validate = (0, validation_1.generateValidator)(NFT.schema);
})(NFT = exports.NFT || (exports.NFT = {}));
//# sourceMappingURL=nft.js.map